const prefix = `Shell`;

export function getDataTestId(id) {
  return `${prefix}-${id}`;
}

export function getTier1DataTestId(id) {
  return getDataTestId(`Tier1-${id}`);
}
